import React from "react";
import Header from "../Components/Header";
import { ReactSession } from 'react-client-session';
import { useNavigate } from "react-router-dom";
import MultipleBanner from "../Components/aboutbanner";
ReactSession.setStoreType("localStorage");


const Home = () => {
    const navigate = useNavigate();
    const userId = ReactSession.get("welbeingId");

    if (userId <= 0) {
        navigate('/login');
    }
    return (
        <>
            <Header />
            <div class="page-wrapper" id="main-wrapper" data-layout="vertical" data-sidebartype="full" data-sidebar-position="fixed" data-header-position="fixed">
                <div class="body-wrapper">
                    <div className="container-fluid">
                        <div className="card bg-light-info shadow-none position-relative overflow-hidden" id="card-home">
                            <div className="card-body">
                                <div className="row align-items-center">
                                    <div className="col-9">
                                        <h4 className="fw-semibold mb-8">Aboutpage Content</h4>
                                        <nav aria-label="breadcrumb">
                                            <ol className="breadcrumb">
                                                <li className="breadcrumb-item"><a className="text-muted" href="dashboard.php">Dashboard</a></li>
                                                <li className="breadcrumb-item" aria-current="page">Homepage content</li>
                                            </ol>
                                        </nav>
                                    </div>
                                    <div className="col-3">
                                        <div className="text-center mb-n5">
                                            <img src="dist/images/breadcrumb/ChatBc.png" alt="" className="img-fluid mb-n4" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <MultipleBanner />
                        
                    </div>
                </div>
            </div>
        </>
    );
}

export default Home;